import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";
import { resolveOaiAdsPixelId } from "@/lib/analytics/oai-config";

export const env = createEnv({
  server: {
    SENTRY_DSN: z.optional(z.string()),
    SENTRY_ENVIRONMENT: z.optional(z.string()),
    SENTRY_TRACES_SAMPLE_RATE: z.optional(z.string()),
    SENTRY_PROFILES_SAMPLE_RATE: z.optional(z.string()),
    POSTHOG_PERSONAL_API_KEY: z.optional(z.string()),
    POSTHOG_PROJECT_ID: z.optional(z.string()),
    POSTHOG_API_BASE: z.optional(z.string()),
    RESEND_API_KEY: z.optional(z.string().min(1)),
    RESEND_INBOUND_WEBHOOK_SECRET: z.optional(z.string().min(1)),
    RESEND_INBOUND_ADDRESS: z.optional(z.email()),
    RESEND_INBOUND_FORWARD_TO: z.optional(z.email()),
    RESEND_NEWSLETTER_SEGMENT_ID: z.optional(z.uuid()),
    RESEND_NEWSLETTER_TOPIC_ID: z.optional(z.uuid()),
    NEWSLETTER_CONFIRMATION_SECRET: z.optional(z.string().min(32)),
  },
  client: {
    NEXT_PUBLIC_APP_URL: z.optional(z.url()),
    NEXT_PUBLIC_POSTHOG_KEY: z.optional(z.string()),
    NEXT_PUBLIC_POSTHOG_HOST: z.optional(z.string()),
    NEXT_PUBLIC_ANALYTICS_INGEST_URL: z.optional(z.string()),
    // OpenAI Ads Measurement Pixel ID. This is a PUBLIC identifier (it ships
    // in client HTML), not a secret, so it is defaulted in `runtimeEnv` below
    // and needs no env var to work. Allow an empty string so an explicit
    // `NEXT_PUBLIC_OAI_ADS_PIXEL_ID=""` can disable the pixel without a deploy
    // (hence no `.min(1)` here — empty means "off", any value overrides).
    NEXT_PUBLIC_OAI_ADS_PIXEL_ID: z.optional(z.string()),
  },
  runtimeEnv: {
    SENTRY_DSN: process.env.SENTRY_DSN,
    SENTRY_ENVIRONMENT: process.env.SENTRY_ENVIRONMENT,
    SENTRY_TRACES_SAMPLE_RATE: process.env.SENTRY_TRACES_SAMPLE_RATE,
    SENTRY_PROFILES_SAMPLE_RATE: process.env.SENTRY_PROFILES_SAMPLE_RATE,
    POSTHOG_PERSONAL_API_KEY: process.env.POSTHOG_PERSONAL_API_KEY,
    POSTHOG_PROJECT_ID: process.env.POSTHOG_PROJECT_ID,
    POSTHOG_API_BASE: process.env.POSTHOG_API_BASE,
    RESEND_API_KEY: process.env.RESEND_API_KEY,
    RESEND_INBOUND_WEBHOOK_SECRET: process.env.RESEND_INBOUND_WEBHOOK_SECRET,
    RESEND_INBOUND_ADDRESS: process.env.RESEND_INBOUND_ADDRESS,
    RESEND_INBOUND_FORWARD_TO: process.env.RESEND_INBOUND_FORWARD_TO,
    RESEND_NEWSLETTER_SEGMENT_ID:
      process.env.RESEND_NEWSLETTER_SEGMENT_ID,
    RESEND_NEWSLETTER_TOPIC_ID: process.env.RESEND_NEWSLETTER_TOPIC_ID,
    NEWSLETTER_CONFIRMATION_SECRET:
      process.env.NEWSLETTER_CONFIRMATION_SECRET,
    NEXT_PUBLIC_APP_URL: process.env.NEXT_PUBLIC_APP_URL,
    NEXT_PUBLIC_POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY,
    NEXT_PUBLIC_POSTHOG_HOST: process.env.NEXT_PUBLIC_POSTHOG_HOST,
    NEXT_PUBLIC_ANALYTICS_INGEST_URL:
      process.env.NEXT_PUBLIC_ANALYTICS_INGEST_URL,
    // Default to the live MLX pixel id (a public identifier, safe to inline
    // in the client bundle) so the pixel works with zero configuration. An
    // env var overrides it — set to "" to disable the pixel entirely.
    NEXT_PUBLIC_OAI_ADS_PIXEL_ID:
      resolveOaiAdsPixelId(process.env.NEXT_PUBLIC_OAI_ADS_PIXEL_ID),
  },
  skipValidation: !!process.env.CI || !!process.env.SKIP_ENV_VALIDATION,
});
